import { INITIAL_PHONE_NUMBER_PREFIX } from "../../constant";

export function getDeviceSpec() {
    const osVersion = getOSVersion();
    const processorSpec = getProcessorSpec();
    const webVersion = getWebVersion();
    
    const specString = `${osVersion}|${processorSpec}|${webVersion}`;
    return btoa(specString).trim();
  }

  export function getOSVersion() {
    try {
      const userAgent = navigator.userAgent;
      let osVersion = '';
  
      if (/Windows NT/.test(userAgent)) {
        const match = userAgent.match(/Windows NT (\d+\.\d+)/);
        osVersion = match?.[1] || "10.0";
      } else if (/Mac OS X/.test(userAgent)) {
        const match = userAgent.match(/Mac OS X (\d+[._]\d+([._]\d+)?)/);
        osVersion = match?.[1]?.replace(/_/g, '.') || "10.15";
      } else if (/Android/.test(userAgent)) {
        const match = userAgent.match(/Android (\d+(\.\d+)?)/);
        osVersion = match?.[1] || "10";
      } else if (/iPhone|iPad/.test(userAgent)) {
        const match = userAgent.match(/OS (\d+[._]\d+([._]\d+)?)/);
        osVersion = match?.[1]?.replace(/_/g, '.') || "14.0";
      } else if (/Linux/.test(userAgent)) {
        osVersion = "Linux";
      } else {
        osVersion = "14.0"; // Default fallback version
      }
  
      return osVersion;
    } catch (error) {
      console.warn('Error getting OS version:', error);
      return "14.0"; // Default fallback version
    }
  }

  export function getProcessorSpec() {
    const platform = navigator.platform;
    const userAgent = navigator.userAgent;
  
    if (/arm64|aarch64/.test(platform) || /arm64/.test(userAgent)) {
      return "64-bit";
    } else if (/armv7|i686/.test(platform) || /armv7/.test(userAgent)) {
      return "32-bit";
    } else {
      return "Unknown";
    }
  }
  
  export function getWebVersion() {
    const userAgent = navigator.userAgent;
    const browserVersion = userAgent.match(/(Chrome|Firefox|Safari|Edge)\/(\d+\.\d+)/);
    return browserVersion ? browserVersion[2] : "Unknown";
  }
  
  export const getFormattedTimestamp = () => {
    return new Date().toLocaleString('en-US', { 
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata'
    }).replace(',', '');
  };


  export const PhoneNumberFormatter = (phoneNumber: string) => {
      // Add +91 if not present at the start
    if (!phoneNumber.startsWith('+91')) {
      // Remove any existing + or 0 at start
      phoneNumber = phoneNumber.replace(/^(\+|0)+/, '');
      phoneNumber =  INITIAL_PHONE_NUMBER_PREFIX + phoneNumber;
      return phoneNumber;
    }
  }